import { Lazy } from '@betgames/bg-state-manager';
import { storageRepository } from '@betgames/bg-tools';
import { headerDataHttpClient } from 'decorators/HeaderDecorator';
import { appFeatures } from 'store/AppFeatures';
import AppRepository from './App.repository';
import AppStore from './App.store';

export const app = new Lazy(
    () =>
        new AppStore(new AppRepository(headerDataHttpClient), storageRepository, appFeatures.store),
);
export { appSelectors } from './App.selectors';
